var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var MediaAnalysisIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 46,
    glyphHeight: 52
  }), React.createElement("path", {
    d: "M35.5217 28.087C35.5217 31.5514 32.7252 34.3479 29.2609 34.3479C25.7965 34.3479 23 31.5514 23 28.087C23 24.6227 25.7965 21.8262 29.2609 21.8262C32.7252 21.8262 35.5217 24.6227 35.5217 28.087ZM29.2609 26.0001C28.113 26.0001 27.1739 26.9392 27.1739 28.087C27.1739 29.2349 28.113 30.174 29.2609 30.174C30.4087 30.174 31.3478 29.2349 31.3478 28.087C31.3478 26.9392 30.4087 26.0001 29.2609 26.0001Z"
  }), React.createElement("path", {
    d: "M45.9565 44.7824C45.9565 48.2467 43.16 51.0432 39.6957 51.0432C36.2313 51.0432 33.4348 48.2467 33.4348 44.7824C33.4348 41.318 36.2313 38.5215 39.6957 38.5215C43.16 38.5215 45.9565 41.318 45.9565 44.7824ZM39.6957 42.6954C38.5478 42.6954 37.6087 43.6345 37.6087 44.7824C37.6087 45.9302 38.5478 46.8693 39.6957 46.8693C40.8435 46.8693 41.7826 45.9302 41.7826 44.7824C41.7826 43.6345 40.8435 42.6954 39.6957 42.6954Z"
  }), React.createElement("path", {
    d: "M41.7826 5.12997V13.4778H4.21739V5.12997H41.7826ZM45.9565 0.956055H0.0434723V17.6517H45.9565V0.956055Z"
  }), React.createElement("path", {
    d: "M8.3913 21.8262H0.0434723V26.0001H8.3913V21.8262Z"
  }), React.createElement("path", {
    d: "M18.8261 30.1738H0.0434723V34.3477H18.8261V30.1738Z"
  }), React.createElement("path", {
    d: "M16.7391 38.5215H0.0434723V42.6954H16.7391V38.5215Z"
  }), React.createElement("path", {
    d: "M10.4783 46.8691H0.0434723V51.0431H10.4783V46.8691Z"
  }), React.createElement("path", {
    d: "M25.087 51.0436H23L43.8696 21.8262H45.9565L25.087 51.0436Z"
  }));
};
export var MediaAnalysisIconGlyph = function (props) {
  return React.createElement(MediaAnalysisIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};